/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
import React, { useEffect, useState } from 'react';
import { useNavigateLegacy as useNavigate } from '@leagueplatform/routing';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { EmailVerification } from '@leagueplatform/engen-capability-shared-library/src/components/email-verification/emailVerification';
import { PhoneVerification } from '@leagueplatform/engen-capability-shared-library/src/components/phone-verification/phoneUpdate';
import { DynamicModal } from '@leagueplatform/engen-capability-shared-library/src/components/layouts/dynamicModal';
import { SuccessModal } from '@leagueplatform/engen-capability-shared-library/src/components/layouts/successModal';

import {
  Box,
  GDSStyleObject,
  StackLayout,
  Modal,
  Button,
  HeadingText,
  Card,
  ParagraphText,
  Checkbox,
} from '@leagueplatform/genesis-core';

import {
  getAccessToken,
  putAccessToken,
} from '@leagueplatform/engen-capability-shared-library/src/utils/api';

import { COMMUNICATION_LIBRARY_ASSET_KEYS } from '../../types/communication-library.types';
import { TermsCondition } from './terms-condition';
import { MedicareInforModal } from './medicareInfoModal';
import { InfoModal } from './InfoModal';
import * as constants from '../../utils/constant';

import Accordion from '../reusable-components/accordian/accordian';
import {
  Preference,
  AllContact,
  AllContactValue,
} from '../../types/accordian.types';

import { checkPaperlessCondition, getLoginBrowser } from '../../utils';

import { communicationLibrary } from '../../communication-library.config';

export function CommunicationLibraryComponent(props: any) {
  const { showModal, setShowModal, plans } = props;
  const [modalOpen, setModalOpen] = useState<boolean>(true);
  const [paperless, setPaperless] = useState<boolean>(false);
  const [emailAuthendicated, setemailAuthendicated] = useState<boolean>(false);

  const [textMessage, setTextMessage] = useState<boolean>(false);
  const [openEmailAddress, setopenEmailAddress] = useState<boolean>(false);
  const [openTermCondition, setOpenTermCondition] = useState<boolean>(false);
  const [checkboxChecked, setCheckboxChecked] = useState<boolean>(false);
  const [showSaveBtn, setShowSaveBtn] = useState<boolean>(false);
  const [cpLoading, setCPLoading] = useState<boolean>(false);
  const [count, setCount] = useState(0);

  const [contactDataLoading, setContactDataLoading] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const [contactData, setContactData] = useState<any[]>([]);
  const [userType, setUserType] = useState<string>('');
  const [showFailedAPI] = useState<boolean>(true);
  const [allContactNumber, setAllContactNumber] = useState<AllContact>({
    mobilePhone: false,
    homePhone: false,
    workPhone: false,
    textPhone: false,
  });

  const [allContactNumberValue, setAllContactNumberValue] =
    useState<AllContactValue>({
      mobilePhone: '',
      homePhone: '',
      workPhone: '',
      textPhone: '',
    });

  const [showPaperlessAlert, setShowPaperlessAlert] = useState<boolean>(false);
  const [cpapiFailure, setCPApiFailure] = useState<boolean>(false);
  const [openPhoneNumber, setopenPhoneNumber] = useState<boolean>(false);
  const [subscribePhoneSer, setSubscribePhoneSer] = useState<boolean>(false);
  const [phoneType, setPhoneType] = useState<string>('Mobile Phone');
  const [newEmailAdded, setNewEmailAdded] = useState<boolean>(false);
  const navigate = useNavigate();

  const [phoneDescription, setPhoneDescription] = useState<string>(
    constants.MOBILE_PHONE_DESCRIPTION,
  );

  const [openSuccess, setOpenSuccess] = useState<boolean>(false);
  const [openEditContact, setEditContact] = useState<boolean>(false);
  const [medicareInforModal, setMedicareInfoModal] = useState<boolean>(false);
  const [infoModal, setInfoModal] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cpData, setCPData] = useState<any[]>([]);
  const [memberDetail, setMemberDetail] = useState<any>({});

  const config = communicationLibrary.getConfig();

  const highmarkURL = config.HIGHMARK_API_URL;

  const contactInfoURL = `${highmarkURL}/digital/v1/members/contact-information/contacts`;

  const getCPURL = `${highmarkURL}/digital/v1/members/communication-preferences/preferences`;

  const [cpStatus, setCpStatus] = useState<Preference>({});

  const [alertModalPreSelectedValue, setAlertModalPreSelectedValue] = useState({
    key: '',
    value: '',
  });

  const [confirmEmail, setConfirmEmail] = useState<boolean>(false);

  const [oldEmail, setOldEmail] = useState<string>('');

  const handleEditContactClose = () => {
    setPaperless(checkPaperlessCondition(cpStatus));
    setCpStatus(cpStatus);
    setEditContact(false);
    setConfirmEmail(false);
  };

  const handleTermsAccept = () => {
    setOpenTermCondition(false);
    setCheckboxChecked(true);
    setShowSaveBtn(true);
  };

  const handleTermsDecline = () => {
    setOpenTermCondition(false);
    setCheckboxChecked(false);
    setShowSaveBtn(false);
  };

  const handleChangeTerms = () => {
    setOpenTermCondition(!openTermCondition);
  };

  const handleCheckboxChange = () => {
    if (checkboxChecked) {
      setCheckboxChecked(false);
      setShowSaveBtn(false);
    } else setOpenTermCondition(!openTermCondition);
  };

  const getPreferenceTitle = (str: string) => {
    let result = '';
    cpData.map((item: any) => {
      if (str === 'invoice') {
        if (item.id === '8') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'eob') {
        if (item.id === '4') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'insurance') {
        if (item.id === '1') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'healthStatement') {
        if (item.id === '12') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'wellness') {
        if (item.id === '2') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'memberNewslater') {
        if (item.id === '5') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'healthCoach') {
        if (item.id === '9') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'otherProducts') {
        if (item.id === '3') {
          result = item.PreferencesTitle;
        }
      } else if (str === 'utilization') {
        if (item.id === '32') {
          result = item.PreferencesTitle;
        }
      } else {
        result = item.PreferencesTitle;
      }

      return result;
    });

    return result;
  };

  const getPreference = () => {
    const preferneces: { name: string; preference: string }[] = [];
    Object.entries(cpStatus).forEach((key) => {
      if (key[1] !== '') {
        const obj = {
          name: getPreferenceTitle(key[0]),
          preference: constants.getPreferenceLabel(key[1]),
        };
        preferneces.push(obj);
      }
    });
    return preferneces;
  };

  const handleEditContact = () => {
    if (['CMS', 'ACAOnExchange'].includes(userType)) {
      if (['CMS'].includes(userType)) {
        setMedicareInfoModal(true);
      } else {
        setInfoModal(true);
      }
    } else {
      setEditContact(true);
    }
  };

  useEffect(() => {
    localStorage.removeItem('sendCount');
  }, []);

  // eslint-disable-next-line consistent-return
  const handlePhone = (e: any) => {
    if (['CMS', 'ACAOnExchange'].includes(userType)) {
      if (!allContactNumber.textPhone && !textMessage) {
        if (['CMS'].includes(userType)) {
          setMedicareInfoModal(true);
        } else {
          setInfoModal(true);
        }
      } else {
        setTextMessage(!textMessage);
        if (e.target.checked) {
          setSubscribePhoneSer(allContactNumber.textPhone);
          setopenPhoneNumber(!allContactNumber.textPhone);
          setPhoneDescription(constants.MOBILE_PHONE_DESCRIPTION);
          setPhoneType('Mobile Phone');
        }
      }
    } else {
      setTextMessage(!textMessage);
      if (e.target.checked) {
        setSubscribePhoneSer(allContactNumber.textPhone);
        setopenPhoneNumber(!allContactNumber.textPhone);
        setPhoneDescription(constants.MOBILE_PHONE_DESCRIPTION);
        setPhoneType('Mobile Phone');
      }
    }
  };

  const handlePhonenumberPaperLess = (id: string, value: string) => {
    setopenPhoneNumber(true);
    setPhoneType(value);
    if (value === 'Mobile Phone' || value === 'Text Message') {
      setPhoneDescription(constants.MOBILE_PHONE_DESCRIPTION);
    } else if (value === 'Work Phone') {
      setPhoneDescription(constants.WORK_PHONE_DESCRIPTION);
    } else if (value === 'Home Phone') {
      setPhoneDescription(constants.HOME_PHONE_DESCRIPTION);
    }
  };

  const handleUserTypeConditions = (e: any) => {
    if (
      checkPaperlessCondition(cpStatus) &&
      e.target.value !== constants.PREFERENCE_OPTION1 &&
      e.target.id !== 'healthCoach'
    ) {
      setAlertModalPreSelectedValue({
        key: e.target.id,
        value: e.target.value,
      });
      setShowPaperlessAlert(true);
    } else if (
      (e.target.value === 'Mobile Phone' && !allContactNumber.mobilePhone) ||
      (e.target.value === 'Work Phone' && !allContactNumber.workPhone) ||
      (e.target.value === 'Home Phone' && !allContactNumber.homePhone) ||
      (e.target.value === 'Text Message' && !allContactNumber.textPhone)
    ) {
      setAlertModalPreSelectedValue({
        key: e.target.id,
        value: e.target.value,
      });
      handlePhonenumberPaperLess(e.target.id, e.target.value);
    } else if (e.target.value === 'Personal Email' && email === '') {
      setopenEmailAddress(true);
    } else if (!emailAuthendicated && e.target.value === 'Personal Email') {
      setAlertModalPreSelectedValue({
        key: e.target.id,
        value: e.target.value,
      });
    } else {
      setCpStatus(
        (prevState) =>
          ({
            ...prevState,
            [e.target.id]: e.target.value,
          } as Pick<Preference, keyof Preference>),
      );
    }
  };

  // eslint-disable-next-line consistent-return
  const handleChangeRadio = (e: any) => {
    e.persist();
    // eslint-disable-next-line no-constant-condition
    if (['CMS', 'ACAOnExchange'].includes(userType)) {
      if (
        (e.target.value === 'Mobile Phone' && !allContactNumber.mobilePhone) ||
        (e.target.value === 'Work Phone' && !allContactNumber.workPhone) ||
        (e.target.value === 'Home Phone' && !allContactNumber.homePhone) ||
        (e.target.value === 'Text Message' && !allContactNumber.textPhone) ||
        (e.target.value === 'Personal Email' && !email)
      ) {
        if (['CMS'].includes(userType)) {
          setMedicareInfoModal(true);
        } else {
          setInfoModal(true);
        }
      } else {
        handleUserTypeConditions(e);
      }
    } else {
      handleUserTypeConditions(e);
    }
  };

  useEffect(() => {
    setPaperless(checkPaperlessCondition(cpStatus));
  }, [cpStatus]);

  const isEmptyobj = !Object.values(cpStatus).some(
    (x) => x !== null && x !== '',
  );

  const lableRemove = (label: any) => {
    if (
      ['Work Phone', 'Mobile Phone', 'Home Phone', 'Text Message'].includes(
        label,
      )
    ) {
      if (['Mobile Phone', 'Text Message'].includes(label)) {
        if (allContactNumberValue?.mobilePhone) {
          return label;
        } else {
          return '';
        }
      } else if (['Work Phone'].includes(label)) {
        if (allContactNumberValue?.workPhone) {
          return label;
        } else {
          return '';
        }
      } else if (allContactNumberValue?.homePhone) {
        return label;
      } else {
        return '';
      }
    } else {
      return label;
    }
  };

  const getCPDetails = (url: any) => {
    setCPLoading(true);
    getAccessToken(url).then((result: any) => {
      setCPLoading(false);
      if (result?.communicationPreferences) {
        const cpDetails: React.SetStateAction<any[]> = [];
        setMemberDetail(result?.memberDetail);
        setTextMessage(
          (allContactNumber?.textPhone || allContactNumber?.mobilePhone) &&
            result?.memberDetail?.textMsgOptFlag,
        );
        // eslint-disable-next-line array-callback-return
        result?.communicationPreferences.map((item: any) => {
          if (item.eligibleFlag) {
            Object.assign(cpStatus, {
              ...cpStatus,
              [constants.getPreferenceNameKey(item.title)]: '',
            });
            cpDetails.push(item);
          }
        });

        setCPData(cpDetails);

        // eslint-disable-next-line array-callback-return
        result?.communicationPreferences.map((item: any) => {
          if (item.eligibleFlag) {
            item.options.map((data: any) => {
              if (data.isSelected) {
                setCpStatus(
                  (prevState) =>
                    ({
                      ...prevState,
                      [constants.getPreferenceNameKey(item.title)]: lableRemove(
                        data.label,
                      ),
                    } as Pick<Preference, keyof Preference>),
                );
              }
              return data;
            });
          }
        });
      }

      if (result.errMsg) {
        setCPApiFailure(true);
      }
    });
  };

  const closeAPIFailureModal = () => {
    setCPApiFailure(false);
  };

  const handleSaveBtnClick = () => {
    setShowSaveBtn(false);
    const updateMemberDetails = {
      ...memberDetail,
      mobileNumber: allContactNumberValue?.textPhone,
      textMsgOptFlag: textMessage,
    };

    const updateObj = {
      memberDetail: updateMemberDetails,
      memberPreferences: getPreference(),
    };

    putAccessToken(getCPURL, updateObj).then((result: any) => {
      setShowSaveBtn(true);
      if (result?.updateStatus) {
        setOpenSuccess(true);
      }
      if (result.errMsg) {
        setCPApiFailure(true);
      }
    });
  };

  const handleAlertModalOkBtn = () => {
    if (
      (alertModalPreSelectedValue.value === 'Mobile Phone' &&
        !allContactNumber.mobilePhone) ||
      (alertModalPreSelectedValue.value === 'Work Phone' &&
        !allContactNumber.workPhone) ||
      (alertModalPreSelectedValue.value === 'Home Phone' &&
        !allContactNumber.homePhone) ||
      (alertModalPreSelectedValue.value === 'Text Message' &&
        !allContactNumber.textPhone)
    ) {
      setCpStatus(
        (prevState: any) =>
          ({
            ...prevState,
          } as Pick<Preference, keyof Preference>),
      );
    } else {
      setCpStatus((prevState: any) => ({
        ...prevState,
        [alertModalPreSelectedValue.key]: alertModalPreSelectedValue.value,
      }));
    }

    setShowPaperlessAlert(false);

    if (
      (alertModalPreSelectedValue.value === 'Mobile Phone' &&
        !allContactNumber.mobilePhone) ||
      (alertModalPreSelectedValue.value === 'Work Phone' &&
        !allContactNumber.workPhone) ||
      (alertModalPreSelectedValue.value === 'Home Phone' &&
        !allContactNumber.homePhone) ||
      (alertModalPreSelectedValue.value === 'Text Message' &&
        !allContactNumber.textPhone)
    ) {
      setopenPhoneNumber(true);

      setPhoneType(alertModalPreSelectedValue.value);

      if (
        alertModalPreSelectedValue.value === 'Mobile Phone' ||
        alertModalPreSelectedValue.value === 'Text Message'
      ) {
        setPhoneDescription(constants.MOBILE_PHONE_DESCRIPTION);
      } else if (alertModalPreSelectedValue.value === 'Work Phone') {
        setPhoneDescription(constants.WORK_PHONE_DESCRIPTION);
      } else if (alertModalPreSelectedValue.value === 'Home Phone') {
        setPhoneDescription(constants.HOME_PHONE_DESCRIPTION);
      }
    }

    setAlertModalPreSelectedValue({
      key: '',
      value: '',
    });
  };

  const getClient = (planss: any) => {
    let planDetail;
    const currentYear =
      planss &&
      planss?.length > 0 &&
      planss?.filter(
        (plan: any) =>
          plan.planType === 'medical' &&
          plan.planYear === 'current' &&
          (plan?.hcrProduct === 'OFF' ||
            plan?.hcrProduct === 'ON' ||
            plan?.mediGapIndicator === 'true' ||
            plan?.medicareAdvIndicator === 'true'),
      );

    if (currentYear?.length === 0) {
      const pastYear =
        planss &&
        planss?.length > 0 &&
        planss?.filter(
          (plan: any) =>
            plan.planType === 'medical' &&
            plan.planYear === 'past' &&
            (plan?.hcrProduct === 'OFF' ||
              plan?.hcrProduct === 'ON' ||
              plan?.mediGapIndicator === 'true' ||
              plan?.medicareAdvIndicator === 'true'),
        );
      if (pastYear?.length === 0) {
        planDetail =
          planss &&
          planss?.length > 0 &&
          planss?.filter(
            (plan: any) =>
              plan.planType === 'medical' &&
              plan.planYear === 'future' &&
              (plan?.hcrProduct === 'OFF' ||
                plan?.hcrProduct === 'ON' ||
                plan?.mediGapIndicator === 'true' ||
                plan?.medicareAdvIndicator === 'true'),
          );
      } else {
        planDetail = pastYear;
      }
    } else {
      planDetail = currentYear;
    }

    return planDetail?.[0];
  };

  useEffect(() => {
    const newPlans = getClient(plans);
    if (
      newPlans?.hcrProduct &&
      newPlans?.hcrProduct !== '' &&
      newPlans?.hcrProduct === 'ON'
    ) {
      setUserType('ACAOnExchange');
    } else if (
      newPlans?.mediGapIndicator === 'true' ||
      newPlans?.medicareAdvIndicator === 'true'
    ) {
      setUserType('CMS');
    } else {
      setUserType('OTHER');
    }
  }, [plans]);

  const getContactDetails = (url: any) => {
    if (count === 0) {
      setCPLoading(true);
    }
    setContactDataLoading(true);
    getAccessToken(url, '').then((result: any) => {
      if (result?.memberContactsResponse) {
        setContactData(result.memberContactsResponse);
        const contactDetail = result.memberContactsResponse[0]?.contactPoints;

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const data =
          contactDetail &&
          contactDetail.length > 0 &&
          contactDetail.map((item: any) => {
            if (setAllContactNumber !== undefined) {
              if (item.use === 'Mobile' && item.type === 'Phone') {
                setAllContactNumber((prevState: any) => ({
                  ...prevState,
                  mobilePhone: true,
                }));
                setAllContactNumberValue((prevState: any) => ({
                  ...prevState,
                  mobilePhone: item.value,
                }));
              } else if (item.use === 'Home' && item.type === 'Phone') {
                setAllContactNumber((prevState: any) => ({
                  ...prevState,
                  homePhone: true,
                }));
                setAllContactNumberValue((prevState: any) => ({
                  ...prevState,
                  homePhone: item.value,
                }));
              } else if (item.use === 'Work' && item.type === 'Phone') {
                setAllContactNumber((prevState: any) => ({
                  ...prevState,
                  workPhone: true,
                }));
                setAllContactNumberValue((prevState: any) => ({
                  ...prevState,
                  workPhone: item.value,
                }));
              } else if (item.use === 'Mobile' && item.type === 'Text') {
                setAllContactNumber((prevState: any) => ({
                  ...prevState,
                  textPhone: true,
                  mobilePhone: true,
                }));
                setAllContactNumberValue((prevState: any) => ({
                  ...prevState,
                  mobilePhone: item.value,
                  textPhone: item.value,
                }));
                // setTextMessage(true);
              } else if (
                item.use === 'Member Supplied' &&
                item.type === 'Email'
              ) {
                setEmail(item.value);
                setemailAuthendicated(item.authentication === 'Authenticated');
                if (setOldEmail !== undefined) {
                  setOldEmail(item.value);
                }
              }
            } else if (
              item.use === 'Member Supplied' &&
              item.type === 'Email'
            ) {
              setEmail(item.value);
              setemailAuthendicated(item.authentication === 'Authenticated');
            }
            return item;
          });
        setContactDataLoading(false);
      }
      setCount(count + 1);
      if (result.errMsg) {
        setCPApiFailure(true);
        setContactDataLoading(false);
      }
    });
  };

  useEffect(() => {
    getContactDetails(contactInfoURL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contactInfoURL]);

  useEffect(() => {
    if (count === 1) {
      getCPDetails(getCPURL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCPURL, count]);

  const handleCloseSuccess = () => {
    setOpenSuccess(false);

    if (alertModalPreSelectedValue?.key) {
      setCpStatus((prevState: any) => ({
        ...prevState,
        [alertModalPreSelectedValue?.key]: alertModalPreSelectedValue?.value,
      }));
    }
    setPaperless(checkPaperlessCondition(cpStatus));
    setCheckboxChecked(false);
    setShowSaveBtn(false);
    if (!alertModalPreSelectedValue?.key) {
      getCPDetails(getCPURL);
      getContactDetails(contactInfoURL);
    }
  };

  const handleCloseSuccessOverall = () => {
    setOpenSuccess(false);
    setPaperless(checkPaperlessCondition(cpStatus));
    setCheckboxChecked(false);
    setShowSaveBtn(false);
    getCPDetails(getCPURL);
    getContactDetails(contactInfoURL);
  };

  const handleCloseMedicare = () => {
    setMedicareInfoModal(false);
  };
  const handleCloseInfo = () => {
    setInfoModal(false);
  };

  const handleChangePaperlessFun = (e: any) => {
    setPaperless(e.target.checked);

    if (e.target.checked) {
      if (email) {
        if (!emailAuthendicated) {
          setConfirmEmail(true);
          setEmail(oldEmail);
        }
        if (emailAuthendicated) {
          // eslint-disable-next-line array-callback-return
          cpData.map((item: any) => {
            if (constants.getPreferenceNameKey(item.title) !== 'healthCoach') {
              setCpStatus(
                (prevState) =>
                  ({
                    ...prevState,
                    [constants.getPreferenceNameKey(item.title)]:
                      constants.PREFERENCE_OPTION1,
                  } as Pick<Preference, keyof Preference>),
              );
            } else {
              setCpStatus(
                (prevState) =>
                  ({
                    ...prevState,
                    // eslint-disable-next-line no-nested-ternary
                    healthCoach: allContactNumber?.mobilePhone
                      ? constants.PREFERENCE_OPTION5
                      : allContactNumber?.homePhone
                      ? constants.PREFERENCE_OPTION4
                      : constants.PREFERENCE_OPTION6,
                  } as Pick<Preference, keyof Preference>),
              );
            }
          });
        }
      } else {
        setopenEmailAddress(true);
      }
    } else {
      cpData.map((item: any) => {
        if (
          constants.getPreferenceNameKey(item.title) !== 'healthStatement' &&
          constants.getPreferenceNameKey(item.title) !== 'healthCoach'
        ) {
          setCpStatus(
            (prevState) =>
              ({
                ...prevState,
                [constants.getPreferenceNameKey(item.title)]:
                  constants.PREFERENCE_OPTION2,
              } as Pick<Preference, keyof Preference>),
          );
        } else if (
          constants.getPreferenceNameKey(item.title) === 'healthCoach'
        ) {
          setCpStatus(
            (prevState) =>
              ({
                ...prevState,
                // eslint-disable-next-line no-nested-ternary
                healthCoach: allContactNumber?.mobilePhone
                  ? constants.PREFERENCE_OPTION5
                  : allContactNumber?.homePhone
                  ? constants.PREFERENCE_OPTION4
                  : constants.PREFERENCE_OPTION6,
              } as Pick<Preference, keyof Preference>),
          );
        } else {
          setCpStatus(
            (prevState) =>
              ({
                ...prevState,
                healthStatement: allContactNumber?.textPhone
                  ? constants.PREFERENCE_OPTION7
                  : constants.PREFERENCE_OPTION3,
              } as Pick<Preference, keyof Preference>),
          );
        }
        return item;
      });
    }
  };

  const handleChangePaperless = (e: any) => {
    if (['CMS', 'ACAOnExchange'].includes(userType)) {
      if (!email) {
        if (['CMS'].includes(userType)) {
          setMedicareInfoModal(true);
        } else {
          setInfoModal(true);
        }
      } else {
        handleChangePaperlessFun(e);
      }
    } else {
      handleChangePaperlessFun(e);
    }
  };

  useEffect(() => {
    if (
      alertModalPreSelectedValue?.value === 'Personal Email' &&
      !emailAuthendicated
    ) {
      setConfirmEmail(true);
      setEmail(oldEmail);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertModalPreSelectedValue]);

  const backGrayIcon = useStaticAsset(
    COMMUNICATION_LIBRARY_ASSET_KEYS.BACK_GRAY_ICON,
  );
  const leafIcon = useStaticAsset(COMMUNICATION_LIBRARY_ASSET_KEYS.LEAF_ICON);

  return (
    <Box>
      <Modal.Root
        open={showModal || modalOpen}
        onOpenChange={() => {
          setModalOpen((previous) => !previous);
        }}
      >
        <Modal.Content
          showCloseButton={false}
          padding={{
            '@initial': '30px 150px',
            '@laptop': '30px 100px',
            '@tablet': '30px 30px',
            '@mobile': '0',
            '@mobileLandscape': '30px',
          }}
          css={
            {
              borderRadius: '12px',
              background: '#fff',
              height: 'auto !important',
              overflowY: 'auto',
              '.genesis.css-3z5yjv': {
                position: 'relative !important',
              },
            } as GDSStyleObject
          }
          width={{ '@initial': '65%', '@laptop': '80%', '@mobile': '100%' }}
          onInteractOutside={(e) => e.preventDefault()}
          data-testid="mainModal"
        >
          <Box
            css={{
              height: 'auto',
              minHeight: '500px',
              padding: '$two $three',
              '@mobile': {
                maxWidth: '100vw',
                width: '100%',
                height: '100vh',
                overflow: 'auto !important',
                paddingTop: ['Safari'].includes(getLoginBrowser())
                  ? '70px'
                  : '32px',
              },
            }}
          >
            <Button
              size="small"
              icon={backGrayIcon as string}
              role="dialog"
              aria-label="Back to Account Management"
              tabIndex={0}
              onClick={() => {
                setModalOpen(false);
                if (setShowModal !== undefined) setShowModal(false);
                navigate('/account-management', { replace: true });
              }}
              css={{
                '.GDS-c-PJLV': {
                  fontSize: '$headingThree',
                  '@tablet': {
                    fontSize: '$headingFour',
                  },
                  '@mobile': {
                    fontSize: '$headingFour',
                  },
                  fontWeight: 700,
                },
                '.GDS-c-UazGY': {
                  paddingRight: '25px',
                  '@mobile': {
                    paddingRight: '10px',
                  },
                },
                background: 'none',
                color: '#66717A',
                padding: '5px',
                margin: '-5px',
                '&:hover,&:active,&:focus': {
                  background: 'none',
                },
                letterSpacing: 0.25,
                marginBottom: '20px',
                position: 'relative',
                left: '-40px',
                '@mobile': {
                  marginBottom: '10px',
                  left: '0px',
                },
              }}
            >
              {constants.BACK_TITLE}
            </Button>

            {cpLoading ? (
              <LoadingIndicator />
            ) : (
              <>
                <HeadingText
                  level="2"
                  size="sm"
                  tabIndex={0}
                  aria-label="Communication Preferences"
                  data-testid="title"
                  css={
                    {
                      fontSize: '$headingOne',
                      '@tablet': {
                        fontSize: '$headingTwo',
                      },
                      '@mobile': {
                        fontSize: '$headingThree',
                      },
                      padding: '20px 0px',
                      color: '#2C3135',
                      letterSpacing: '0.25px',
                      '@media only screen and (max-width: 767px) and (min-width: 641px)':
                        {
                          fontSize: '21px',
                        },
                    } as GDSStyleObject
                  }
                >
                  {constants.TITLE}
                </HeadingText>

                <Modal.Description>
                  <ParagraphText
                    data-testid="head-des1"
                    css={
                      {
                        fontSize: '$bodyOne',
                        lineHeight: '40px',
                        letterSpacing: 0.25,
                        color: 'rgba(0, 0, 0, 0.80)',
                        '@mobile': {
                          lineHeight: '24px',
                        },
                      } as GDSStyleObject
                    }
                  >
                    {constants.HEADER_DESC}
                  </ParagraphText>
                </Modal.Description>
                <Modal.Description>
                  <ParagraphText
                    data-testid="head-des2"
                    css={
                      {
                        fontSize: '$bodyOne',
                        lineHeight: '40px',
                        letterSpacing: 0.25,
                        color: 'rgba(0, 0, 0, 0.80)',
                        '@mobile': {
                          lineHeight: '24px',
                        },
                      } as GDSStyleObject
                    }
                  >
                    {constants.OPTION_TITLE}
                  </ParagraphText>
                </Modal.Description>

                <Card.Flat
                  css={{
                    background: '#E3F7F0',
                    margin: '40px 0px 20px 0px',
                    borderRadius: '0px',
                  }}
                >
                  <Card.Section css={{ padding: '$one' }}>
                    <StackLayout
                      horizontalAlignment="start"
                      css={{ flexDirection: 'row' }}
                      data-testid="select-paperless"
                    >
                      <img
                        src={leafIcon as string}
                        alt="leaf icon"
                        width="31px"
                        style={{ margin: '5px' }}
                      />
                      <HeadingText
                        level="display"
                        size="sm"
                        data-testid="paperless-header"
                        css={
                          {
                            fontSize: 18,
                            fontStyle: 'normal',
                            fontWeight: 700,
                            lineHeight: '40px',
                            letterSpacing: 0.25,
                            color: '#2C3135',
                          } as GDSStyleObject
                        }
                      >
                        {constants.OPTION_HEADER}
                      </HeadingText>
                    </StackLayout>

                    <Checkbox
                      id="email-checkbox"
                      label={constants.OPTION1}
                      layout="inline"
                      name="cpemail"
                      css={{
                        '.GDS-checkbox-label': {
                          cursor: 'pointer',

                          '&:focus': {
                            outline: '1px solid #0074C9 !important',
                          },
                        },
                        '.GDS-checkbox-input': {
                          '@mobile': {
                            marginRight: '10px !important',
                          },
                        },
                        '.GDS-checkbox-label-text': {
                          fontSize: 16,
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: '24px',
                          letterSpacing: '-0.176px',
                          color: 'rgba(0, 0, 0, 0.80)',
                        },
                      }}
                      checked={paperless}
                      onChange={(e) => handleChangePaperless(e)}
                    />
                    <Checkbox
                      id="text-checkbox"
                      label={constants.OPTION2}
                      onChange={(e) => handlePhone(e)}
                      name="cptext"
                      layout="inline"
                      css={{
                        '.GDS-checkbox-label': {
                          cursor: 'pointer',

                          '&:focus': {
                            outline: '1px solid #0074C9 !important',
                          },
                        },
                        '.GDS-checkbox-input': {
                          '@mobile': {
                            marginRight: '10px !important',
                          },
                        },
                        '.GDS-checkbox-label-text': {
                          fontSize: 16,
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: '24px',
                          letterSpacing: '-0.176px',
                          color: 'rgba(0, 0, 0, 0.80)',
                        },
                      }}
                      checked={textMessage}
                    />
                    {(paperless || textMessage) && (
                      <StackLayout
                        horizontalAlignment="start"
                        css={{
                          flexDirection: 'row',
                          float: 'right',
                          marginBottom: '-5px',
                        }}
                      >
                        <Button
                          size="small"
                          tabIndex={0}
                          css={
                            {
                              color: '#0074C9',
                              cursor: 'pointer',
                              fontWeight: '700',
                              fontSize: 16,
                              padding: '0px',
                              lineHeight: '24px',
                              letterSpacing: '-0.2px',
                              background: 'none',
                              borderRadius: '5px',

                              '&:hover,&:active,&:focus': {
                                background: 'none',
                              },
                            } as GDSStyleObject
                          }
                          onClick={handleEditContact}
                        >
                          {constants.EDIT_TEXT}
                        </Button>
                      </StackLayout>
                    )}
                  </Card.Section>
                </Card.Flat>

                <ParagraphText
                  css={
                    {
                      fontSize: 16,
                      fontStyle: 'normal',
                      fontWeight: 400,
                      lineHeight: '24px',
                      letterSpacing: '-0.176px',
                      color: 'rgba(0, 0, 0, 0.80)',
                      padding: '20px 0px',
                    } as GDSStyleObject
                  }
                >
                  {constants.PREFERENCE_TITLE}
                </ParagraphText>

                <Accordion
                  items={cpData}
                  handleChange={handleChangeRadio}
                  result={cpStatus}
                />

                <HeadingText
                  level="display"
                  size="sm"
                  css={
                    {
                      fontSize: 16,
                      fontStyle: 'normal',
                      fontWeight: 500,
                      lineHeight: '24px',
                      letterSpacing: '-0.176px',
                      color: '#000',
                      margin: '30px 10px 15px 10px',
                    } as GDSStyleObject
                  }
                >
                  {constants.CONDITION_HEADER}
                </HeadingText>
                <Checkbox
                  id="terms-checkbox"
                  label={constants.TERMS_CONDITION}
                  name="confirmcheckbox"
                  checked={checkboxChecked}
                  onChange={handleCheckboxChange}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleCheckboxChange();
                    }
                  }}
                  tabIndex={0}
                  data-testid="terms-conditions"
                  css={
                    {
                      '.GDS-checkbox-label-text': {
                        fontSize: 16,
                        '@tablet': {
                          fontSize: 14,
                        },
                        fontStyle: 'normal',
                        fontWeight: 700,
                        lineHeight: '25.5px',
                        letterSpacing: '-0.2px',
                        color: '#0074C9',
                        cursor: 'pointer',
                      },

                      background: 'none',
                      padding: '0px',

                      '.GDS-checkbox-label': {
                        background: 'none',
                      },
                      '.GDS-checkbox-input': {
                        '@mobile': {
                          marginRight: '10px !important',
                        },
                      },
                      '@media screen and (max-width: 454px) ': {
                        '.GDS-checkbox-label-text': {
                          marginTop: '-10px',
                        },
                      },
                      '@media screen and (max-width: 767px) and (min-width: 641px) ':
                        {
                          '.GDS-checkbox-label-text': {
                            marginTop: '-10px',
                          },
                        },
                    } as GDSStyleObject
                  }
                />
                <StackLayout
                  css={{
                    textAlign: 'center',
                    marginTop: '80px',
                    height: 'auto',
                  }}
                  horizontalAlignment="center"
                >
                  <Button
                    css={
                      {
                        borderRadius: '99999px',
                        color: '#fff',
                        fontSize: 16,
                        fontStyle: 'normal',
                        fontWeight: 700,
                        lineHeight: '25.5px',
                        letterSpacing: '-0.2px',
                        textAlign: 'center',
                        display: 'flex',
                        padding: '12px 32px',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '8px',
                        '&:hover': {
                          color: '#fff',
                        },
                        '&:disabled': {
                          color: '#5A656D',
                        },
                      } as GDSStyleObject
                    }
                    disabled={!showSaveBtn || isEmptyobj}
                    data-testid="save-preference"
                    onClick={handleSaveBtnClick}
                  >
                    {constants.SAVE_BTN}
                  </Button>

                  <TermsCondition
                    openTermCondition={openTermCondition}
                    handleChangeTerms={handleChangeTerms}
                    handleAcceptFun={handleTermsAccept}
                    handleDeclineFun={handleTermsDecline}
                  />

                  <EmailVerification
                    setCpStatus={setCpStatus}
                    showPaperlessAlert={showPaperlessAlert}
                    setShowPaperlessAlert={setShowPaperlessAlert}
                    setAllContactNumber={setAllContactNumber}
                    openPhoneNumber={openPhoneNumber}
                    setopenPhoneNumber={setopenPhoneNumber}
                    setConfirmEmail={setConfirmEmail}
                    confirmEmail={confirmEmail}
                    handleEditContactClose={handleEditContactClose}
                    subscribePhoneSer={subscribePhoneSer}
                    setSubscribePhoneSer={setSubscribePhoneSer}
                    openEditContact={openEditContact}
                    phoneType={phoneType}
                    setPhoneType={setPhoneType}
                    setPhoneDescription={setPhoneDescription}
                    phoneDescription={phoneDescription}
                    alertModalPreSelectedValue={alertModalPreSelectedValue}
                    setAlertModalPreSelectedValue={
                      setAlertModalPreSelectedValue
                    }
                    setOldEmail={setOldEmail}
                    oldEmail={oldEmail}
                    showDiffEmailBtn={
                      !['CMS', 'ACAOnExchange'].includes(userType)
                    }
                    email={email}
                    setEmail={setEmail}
                    setTextMessage={setTextMessage}
                    handleCloseSuccess={handleCloseSuccess}
                    allContactNumber={allContactNumber}
                    allContactNumberValue={allContactNumberValue}
                    contactData={contactData}
                    contactDataLoading={contactDataLoading}
                    getContactDetails={getContactDetails}
                    handleAlertModalOkBtn={handleAlertModalOkBtn}
                    setNewEmailAdded={setNewEmailAdded}
                    newEmailAdded={newEmailAdded}
                    openEmailAddress={openEmailAddress}
                    setopenEmailAddress={setopenEmailAddress}
                  />

                  <PhoneVerification
                    setCpStatus={setCpStatus}
                    showPaperlessAlert={showPaperlessAlert}
                    setShowPaperlessAlert={setShowPaperlessAlert}
                    setAllContactNumber={setAllContactNumber}
                    openPhoneNumber={openPhoneNumber}
                    setopenPhoneNumber={setopenPhoneNumber}
                    handleEditContactClose={handleEditContactClose}
                    subscribePhoneSer={subscribePhoneSer}
                    setSubscribePhoneSer={setSubscribePhoneSer}
                    textMessage={textMessage}
                    openEditContact={openEditContact}
                    phoneType={phoneType}
                    showDiffEmailBtn={
                      !['CMS', 'ACAOnExchange'].includes(userType)
                    }
                    setPhoneType={setPhoneType}
                    setPhoneDescription={setPhoneDescription}
                    phoneDescription={phoneDescription}
                    alertModalPreSelectedValue={alertModalPreSelectedValue}
                    setAlertModalPreSelectedValue={
                      setAlertModalPreSelectedValue
                    }
                    setOldEmail={setOldEmail}
                    allContactNumberValue={allContactNumberValue}
                    email={email}
                    setEmail={setEmail}
                    setTextMessage={setTextMessage}
                    allContactNumber={allContactNumber}
                    setContactDataLoading={setContactDataLoading}
                    contactDataLoading={contactDataLoading}
                    contactData={contactData}
                    getContactDetails={getContactDetails}
                  />
                </StackLayout>
              </>
            )}
            {cpapiFailure && (
              <DynamicModal
                open={cpapiFailure}
                showDiffEmailBtn={showFailedAPI}
                type="API_FAILED"
                heading={constants.API_FAILED_TITLE}
                description={constants.API_FAILED_CONTENT}
                description2={constants.API_FAILED_CONTENTSECOND}
                saveBtn={constants.OK}
                cancelBtn={constants.CANCEL_BTN}
                onClose={closeAPIFailureModal}
                saveBtnHandler={handleAlertModalOkBtn}
              />
            )}

            <SuccessModal
              open={openSuccess}
              onClose={handleCloseSuccessOverall}
              heading={constants.SUCCESS}
              description={constants.PREFERENCES_SAVED}
              btnText={constants.OK}
            />

            <MedicareInforModal
              open={medicareInforModal}
              onClose={handleCloseMedicare}
              heading={constants.ATTENTION}
              description={constants.MEDICARE_INFO}
              btnText={constants.OK}
            />

            <InfoModal
              open={infoModal}
              onClose={handleCloseInfo}
              heading={constants.ATTENTION}
              description={constants.ONEXCHANGE_INFO}
              btnText={constants.OK}
            />
          </Box>
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
